import {
  MULTISELECT_FILTER,
  RANGE_FILTER,
  FilteredItem,
  FilterValueObject,
  SetFilterObject,
  FilterObject,
  FilteredItemWithFilterType,
} from '@as-react/common-types';
import { isMultiSelectFilter, isRangeFilter } from './productSearch.util';

const convertRawFilterValueUrlToCleanArray = (rawFilterValue: string) => {
  let resultList: Array<string>;

  switch (true) {
    case rawFilterValue.startsWith('('):
    case rawFilterValue.startsWith('['):
    case rawFilterValue.startsWith('{'):
      resultList = rawFilterValue.slice(1, -1).split(';');
      break;

    default:
      resultList = rawFilterValue.split(';');
      break;
  }

  return resultList;
};

const createFilteredItemsForRange = (filterValue: string): Array<FilteredItem> => {
  return convertRawFilterValueUrlToCleanArray(filterValue).map(key => ({
    filterKey: key,
  }));
};

const createFilteredItemsForMultiSelect = (values: Array<FilterValueObject>): Array<FilteredItem> => {
  return values
    .filter(value => value.active)
    .map(value => ({
      filterKey: value.filterKey,
      filterKeyName: value.name,
    }));
};

const mapSetFilterObjectToFilteredItemWithFilterType = (
  setFilterObject: SetFilterObject
): FilteredItemWithFilterType => {
  let data: FilteredItemWithFilterType = {
    filterType: setFilterObject.filterType,
    filterOnName: setFilterObject.filterOnName,
    filterContentType: setFilterObject.filterContentType,
  };

  if (isMultiSelectFilter(setFilterObject)) {
    data = {
      ...data,
      values: [...setFilterObject.filteredItems],
    };
  } else if (isRangeFilter(setFilterObject)) {
    data = {
      ...data,
      rangeMin: Math.trunc(Number(setFilterObject.filteredItems[0]!.filterKey)),
      rangeMax: Math.trunc(Number(setFilterObject.filteredItems[1]!.filterKey)),
      filterPrefix: setFilterObject.filterPrefix,
      filterSuffix: setFilterObject.filterSuffix,
    };
  }

  return data;
};

const getFilterType = (type: string) => (type === 'RANGE' ? RANGE_FILTER : MULTISELECT_FILTER);

export const generateActiveFilter = (
  filterOn: string,
  filterValue: string,
  filters: Array<FilterObject>
): FilteredItemWithFilterType | null => {
  const usedFilter = filters.filter(filter => filter.filterOn === filterOn)[0];

  if (usedFilter) {
    const filterType = getFilterType(usedFilter.type);

    const filteredItems =
      filterType === RANGE_FILTER
        ? createFilteredItemsForRange(filterValue)
        : createFilteredItemsForMultiSelect(usedFilter.values);

    const setFilterObject: SetFilterObject = {
      filterType,
      filterOn,
      filterContentType: usedFilter.filterContentType,
      filterOnName: usedFilter.name,
      filteredItems: filteredItems.map(filteredItem => ({
        ...filteredItem,
      })),
      filterPrefix: usedFilter.filterPrefix,
      filterSuffix: usedFilter.filterSuffix,
    };

    return mapSetFilterObjectToFilteredItemWithFilterType(setFilterObject);
  }

  return null;
};
